import * as core from '../../../../../../../core'
import * as sr from '../sr'

export const RESOURCE = {
  payload: {
    alias: 'external-institutions',
    appAlias: sr.RESOURCE.payload.alias,
    description: 'External Institutions',
    display: {
      isMain: true,
      position: 3,
    },
    name: 'External Institutions',
    page: { alias: 'sr:external-institutions' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
